import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import InstitutionIconsLinkOrAddAccountsContent from 'Components/ComponentLibrary/Organisms/LinkOrAddAccounts/InstitutionIcons/LinkOrAddAccountsContent';
import classNames from 'classnames';
import { StepNavigatorWrapper } from 'Components/ComponentLibrary/Molecules/StepNavigator/StepNavigatorWrapper';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import AggregatorButtonPicker from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/AggregatorButtonPicker';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDBox, FDDialogContent, FDDialogTitle } from '@facet-wealth/design';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';

const useStyles = buildUseStyles('InstitutionIconsLinkOrAddAccountsTemplate', (theme) => ({
  // Below drawer, above top nav
  sideBarZIndex: {
    zIndex: theme.zIndex.sideBar,
  },
  continueBtn: {
    display: 'flex',
    flex: 1,
  },
}));

const InstitutionIconsLinkOrAddAccountsTemplate = () => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();
  const { loadModalCollectionByLink } = useModalContext();
  const { refreshOnboardingStepCollection } = useSurveyContext();

  function onLoadLink(link) {
    loadModalCollectionByLink(link.url());
    refreshOnboardingStepCollection();
  }

  return (
    <>
      <FDDialogTitle />
      <FDDialogContent>
        <FDBox padding={0}>
          <InstitutionIconsLinkOrAddAccountsContent
            resource={resource}
            onLoadLink={loadModalCollectionByLink}
            classes={classes}
            showAccountLinkingText={false}
          />
          <div className={classNames(classes.sideBarZIndex)}>
            <StepNavigatorWrapper className={classes.sideBarZIndex}>
              <AggregatorButtonPicker
                resource={resource}
                onLoadLink={onLoadLink}
                renderButtonComponentChildren={() => 'Continue'}
                classes={{ root: classes.continueBtn }}
                ButtonComponent={RoundedButton}
                ButtonComponentProps={{
                  variant: 'contained',
                  color: 'primary',
                  fullWidth: true,
                  size: 'sm',
                  'data-test': 'link-institution-button',
                }}
              />
            </StepNavigatorWrapper>
          </div>
        </FDBox>
      </FDDialogContent>
    </>
  );
};

InstitutionIconsLinkOrAddAccountsTemplate.defaultProps = {
  className: '',
};

InstitutionIconsLinkOrAddAccountsTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default InstitutionIconsLinkOrAddAccountsTemplate;
